import { render, staticRenderFns } from "./jean-marc-boillot.vue?vue&type=template&id=61b03c8e&scoped=true"
import script from "./jean-marc-boillot.vue?vue&type=script&lang=js"
export * from "./jean-marc-boillot.vue?vue&type=script&lang=js"
import style0 from "./jean-marc-boillot.vue?vue&type=style&index=0&id=61b03c8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b03c8e",
  null
  
)

export default component.exports